export class VarParamI{
    id : number;
    nombre : string;
    subitem : Boolean;
    operestadistica : number;
    orden : any;
}
